module.exports = __webpack_public_path__ + "location_mark.774dd2e95512e56243dc.svg";